export const colors = {
  // Modal Body Css //
  modalInputBorder: "#d1d5db",
  paginationButtonDisabledBg: "#1f2937",
  paginationButtonText: "#ffffff",
  modalTableHeader: "#1f2937",
  modalTableHeaderText: "#ffffff",
  modalTableBody: "#ffffff",

  // Table Component Css
  searchInputBorder: "#d1d5db",
  searchInputShadow: "red",
  filterButtonsActive: "#384B70",
  filterButtonsUnActive: "#6b7280",
  filterButtonsText: "#ffffff",
  evenRowBackground: "#fafafa",
  oddRowBackground: "#ffffff",
  tableHeader: "#f3f4f6",
  tableHeaderText: "#6b7280",
  tableDivisionColor: "#111827",
};
